import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';

interface LegalLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

const LegalLayout: React.FC<LegalLayoutProps> = ({ title, lastUpdated, children }) => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <main className="pt-16">
        {/* Header */}
        <section className="bg-gradient-to-br from-orange-50 to-red-50 py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <Link
                to="/"
                className="inline-flex items-center text-orange-600 hover:text-orange-700 transition-colors mb-8"
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                {t('legal.backHome')}
              </Link>
              
              <h1 className="text-4xl font-bold text-gray-900 mb-4">
                {title}
              </h1>
              
              <p className="text-gray-600 text-lg">
                {t('legal.lastUpdated')}: {lastUpdated}
              </p>
            </motion.div>
          </div>
        </section>

        {/* Content */}
        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="prose prose-lg max-w-none"
            >
              {children}
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default LegalLayout;